import React, {Component} from 'react'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux'
import { JOIN_GUILD, LEAVE_GUILD, SET_GUILDS, SET_ACTIVE_GUILD } from '../../Actions/Guilds'
import { GET_CURRENT_USER } from '../../Actions/User'

class GuildCard extends Component {

    handleJoin = (_id, group)=> {
        this.props.actions.JOIN_GUILD(_id).then(res => {
            this.props.actions.SET_GUILDS()
            this.props.actions.GET_CURRENT_USER(this.props.user)
        })
    }

    handleLeave = (_id)=> {
        this.props.actions.LEAVE_GUILD(_id).then(res => {
        })
        this.props.actions.GET_CURRENT_USER(this.props.user)

    }

    handleGoto = (e, _id, group)=> {
        if(e.target.classList.contains('c-btn')) return;

        this.props.actions.SET_ACTIVE_GUILD(group)

        this.props.history.push({
            pathname: `/community/groups/${_id}`,
            group: group,
        })
    }

    render() {
        const { group_id, title, sub_count, group, isMember } = this.props;      
        return (
            <div className="c-card c-card--alt" onClick={(e)=> this.handleGoto(e, group_id, group)}>
                <div className="c-card__inner">
                    <div className="c-card__content">
                        <span className="c-card__title">{title}</span>
                        <div className="c-card__opt">
                            {sub_count} {sub_count === '1' ? 'lid' : 'leden'}
                        </div>
                    </div>

                    {
                        isMember && (
                            <button className="c-btn c-btn--alt c-btn--primary c-list-btn" onClick={()=> this.handleLeave(group_id)}>Lidmaatschap intrekken</button>
                        )
                    }

                    {
                        !isMember && (
                            <button className="c-btn c-btn--alt c-btn--primary c-list-btn" onClick={()=> this.handleJoin(group_id, group)}>Word lid</button>
                        )
                    }

                </div>
            </div>
        )
    }
}
const mapStateToProps = state => {
    return {
        user: state.user.user,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators({JOIN_GUILD, LEAVE_GUILD, SET_GUILDS, SET_ACTIVE_GUILD, GET_CURRENT_USER}, dispatch)
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(GuildCard))